import React from 'react';
import { find, isNull } from 'lodash';

import { DonutChart, SimpleDonutChart } from '@magoosh/lib/charts';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  examName: string;
  filters: any;
}

const PercentCorrectChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <SimpleDonutChart
      chartProps={{ animate: false }}
      colorPalette={{ dark: colors.gray85, light: colors.grayLightest }}
      data={60}
      interior={<></>}
      size={150}
    />
  );

  const formatStatisticData = (statisticData) => {
    return statisticData.map((datum) => {
      const formattedData = {
        label: datum.name,
        value: datum.value
      } as any;

      const predeterminedColor = {
        'Correct': colors.dataDarkPurple,
        'Incorrect': colors.dataMutedPurple,
        'Not Graded': colors.grayLighter
      }[datum.name];

      if (predeterminedColor) {
        formattedData.color = predeterminedColor;
      }

      return formattedData;
    });
  };

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        formatDataFn={formatStatisticData}
        name="percent_correct"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <Chart />
      </StatisticData>
    );
  }
};

const Chart = ({ data }) => {
  if (find(data, (series) => series.label === 'Not Graded')) {
    return (
      <DonutChart
        chartProps={{ animate: false }}
        data={data}
        formatValueFn={(value) => `${value}%`}
        interior={(data) => {
          if (isNull(data)) {
            return (
              <strong>
                <span style={{ color: colors.dataDarkPurple, fontSize: 150 * 0.2 }}>-</span>
              </strong>
            );
          } else {
            const percentCorrect = find(data, (series) => series.label === 'Correct').value;

            return (
              <strong>
                <span style={{ color: colors.dataDarkPurple, fontSize: 150 * 0.25 }}>{percentCorrect}</span>
                <span style={{ color: colors.dataDarkPurple, fontSize: 150 * 0.15 }}>%</span>
              </strong>
            );
          }
        }}
        size={150}
      />
    );
  } else {
     return (
      <SimpleDonutChart
        chartProps={{ animate: false }}
        colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
        data={data[0].value}
        size={150}
      />
    );
  }
};

export default PercentCorrectChart;
